import React, { Component } from "react";

const API_KEY = "AIzaSyAxrLp1lOIuP4twINmY0yNVHI8BVBPsYRE"
class ContactForm extends Component {
    constructor(props) {
        super(props)
        this.state = {
            
        };
        this.handleChange = this.handleChange.bind(this)
    }

    handleChange(event) {
        this.props.onChange(event);
    }
    
    render() {
        return (
            <form>
            <div className="row">
                <div className="col-md-6">
                        <div className="form-group">
                            <label>Title</label>
                            <select
                                name="ContactTitle"
                                id="ContactTitle"
                                className="form-control wizard-stage-2-optional-1"
                                onChange={(val) => this.handleChange(val)} >
                                <option value="mr">Mr.</option>
                                <option value="mrs">Mrs.</option>
                            </select>
                        </div>
                        <div className="form-group">
                            <label className="control-label">
                                First Name
                            </label>
                            <input
                                type="text"
                                className="form-control"
                                name="ContactFirstName"
                                id="ContactFirstName"
                                onChange={(val) => this.handleChange(val)}
                            />
                        </div>
                        <div className="form-group">
                            <label className="control-label">
                                Last Name
                                                                    </label>
                            <input
                                type="text"
                                className="form-control "
                                name="ContactLastName"
                                id="ContactLastName"
                                onChange={(val) => this.handleChange(val)}
                            />
                        </div>
                        <div className="form-group">
                            <label className="control-label">
                                Phone Number
                                                                    </label>
                            <input
                                type="text"
                                className="form-control "
                                name="ContactPhoneNumber"
                                id="ContactPhoneNumber"
                                onChange={(val) => this.handleChange(val)}
                            />
                        </div>
                </div>
                <div className="col-md-6">
                    <div className="form-group">
                        <label className="control-label">
                            Address
                                                                    </label>
                        <input
                            type="text"
                            className="form-control"
                            name="ContactAdress"
                            id="ContactAdress"
                            onChange={(val) => this.handleChange(val)}
                        />
                    </div>
                    <div className="row">
                        <div className="col-md-4">
                            <div className="form-group">
                                <label className="control-label">
                                    City
                                                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    name="ContactCity"
                                    id="ContactCity"
                                    onChange={(val) => this.handleChange(val)}
                                />
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="form-group">
                                <label className="control-label">
                                    State
                                                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    name="ContactState"
                                    id="ContactState"
                                    onChange={(val) => this.handleChange(val)}
                                />
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="form-group">
                                <label className="control-label">
                                    Zip Code
                                                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    name="ContactZipCode"
                                    id="ContactZipCode"
                                    onChange={(val) => this.handleChange(val)}
                                />
                            </div>
                        </div>
                        </div>
                    </div>
                </div>
                <ul className="pager wizard">
                    <li className="previous">
                        <button className="btn btn-secondary" onClick={() => this.props.onPreviousPage()}>
                            <i className="batch-icon batch-icon-arrow-left" />
                        </button>
                    </li>
                    <li className="next">
                        <button className="btn btn-primary" onClick={() => this.props.onNextPage()}> Next </button>
                    </li>
                </ul>
                </form>
        );
    }
}
export default ContactForm;


// WEBPACK FOOTER //
// ./src/view/Creditability/ContactForm.jsx